<template>
  <div class="activity-detail grey-bg" v-if="detail">
    <div class="activity-head">
      <div class="scenics">
        <swiper :options="swiperOption" v-if="detail.slider_image.length > 0">
          <swiper-slide
            v-for="(item, index) in detail.slider_image"
            :key="index"
          >
            <div
              class="scenic-img"
              :style="
                'background-image: url(' +
                  item +
                  '?x-oss-process=image/resize,w_520);'
              "
            ></div>
          </swiper-slide>
          <div
            class="swiper-pagination paginationBanner"
            slot="pagination"
          ></div>
        </swiper>
      </div>

      <!-- <div class="scenics-count">
        <a class="scenics-count-link">50张</a>
      </div> -->
    </div>

    <div class="activity-base">
      <div class="product-con" v-if="detail.type != typeAct">
        <div class="wrapper">
          <div class="share acea-row row-between row-bottom">
            <div class="money font-color-red">
              ￥<span class="num">{{ detail.price }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="activity-base-head">
        <div class="activity-name">
          <!-- <div class="shareable">共享</div> -->
          {{ detail.store_name }}
        </div>
        <!-- 长线活动的标签 -->
        <div class="activity-guide">
          <div class="guide-left" style="position:relative;">
            <a class="guide-avatar-link">
              <img class="guide-avatar" v-lazy="detail.main_leader.avatar" />
            </a>
          </div>
          <div class="guide-info">
            <div class="guide-info-body">
              <div class="guide-info-base">
                <div class="guide-name">
                  {{ detail.main_leader.leader_name }}
                </div>
                <i class="guide-level" />
              </div>
              <!-- <div class="guide-grade">评分：4.94（945人评）</div> -->
            </div>
          </div>
          <div class="activity-collect">
            <div
              class="activity-collect-wrapper"
              v-if="detail.userCollect === false"
              @click="collectActivity"
            >
              <div class="collect-mark">
                <div class="collect-img"></div>
              </div>
              <div class="collec-text">
                收藏活动
              </div>
            </div>
            <div
              class="activity-collect-wrapper"
              v-else
              @click="cancelCollectActivity"
            >
              <div class="collect-mark">
                <div class="collect-img active"></div>
              </div>
              <div class="collec-text">
                已收藏
              </div>
            </div>
          </div>
          <div class="collect-left-holder"></div>
          <div class="clearfix"></div>

          <div
            v-if="detail.type != typeAct && detail.expire_date"
            style="padding: 5px 0;"
          >
            截止日期：<span class="atterTxt">{{ detail.expire_date }}</span>
          </div>
        </div>
        <!-- <div class="activity-difficult-level">
          难度：<span class="activity-difficult-mark">★深度游</span
          >&nbsp;&nbsp;<span>+262学分</span>
        </div> -->

        <div class="activity-together" v-if="detail.type == typeAct">
          <div class="activity-spot">集合：{{ detail.venue }}集中</div>
          <div @click="showOtherPrice = !showOtherPrice">
            <span class="activity-price-ps-person">{{ detail.price }}</span
            >元
            <span class="beginning-icon"></span>
          </div>
          <transition
            name="bounce"
            v-if="detail.price_child > 0 || detail.price_baby > 0"
          >
            <div style="width: 100%;" v-if="showOtherPrice">
              <div class="price-child" v-if="detail.price_child > 0">
                <span class="activity-price-ps-person">{{
                  detail.price_child
                }}</span
                >元/人<span class="price-tip">(1.2米以上儿童)</span>
              </div>
              <div class="price-child" v-if="detail.price_baby > 0">
                <span class="activity-price-ps-person">{{
                  detail.price_baby
                }}</span
                >元/人<span class="price-tip">(1.2米以下儿童)</span>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div class="product-con" style="margin-bottom: 10px">
        <div
          v-if="detail.type != typeAct"
          class="attribute acea-row row-between-wrapper"
          @click="selecAttrTap"
        >
          <div>
            {{ attrTxt }}：<span class="atterTxt">{{ attrValue }}</span>
          </div>
          <div class="iconfont icon-jiantou"></div>
        </div>
        <div class="wrapper">
          <div
            class="coupon acea-row row-between-wrapper"
            @click="couponTap"
            v-if="couponList.length"
          >
            <div class="hide line1 acea-row">
              优惠券：
              <div
                class="activity"
                v-for="(item, index) in couponList"
                :key="index"
              >
                满{{ item.use_min_price }}减{{ item.coupon_price }}
              </div>
            </div>
            <div class="iconfont icon-jiantou"></div>
          </div>
        </div>

        <div class="userEvaluation" v-if="replyCount">
          <div class="title acea-row row-between-wrapper">
            <div>用户评价({{ replyCount }})</div>
            <router-link :to="{ path: '/evaluate_list/' + id }" class="praise"
              ><span class="font-color-red">{{ replyChance }}%</span>好评率<span
                class="iconfont icon-jiantou"
              ></span
            ></router-link>
          </div>
          <user-evaluation :reply="reply"></user-evaluation>
        </div>
      </div>

      <div class="activity-timeline" v-if="detail.type == typeAct">
        <div class="activity-timeline-title">
          <div class="beginning-wrapper">
            <div
              class="beginning"
              data-slectcityid="12"
              style="min-width:56px;"
            >
              <select v-model="cityId" @change="changeCity(cityId)">
                <option
                  v-for="(city, index) in detail.city_list"
                  :value="city.city_id"
                  :key="index"
                  >{{ cities[city.city_id].name }}出发</option
                >
              </select>
              <div class="beginning-icon"></div>
            </div>
          </div>
        </div>
        <div class="activity-schedule" style="min-height:85px;">
          <div class="activity-schedule-loading">
            加载中...
          </div>
          <div class="activity-timeline-horiz-mover"></div>
          <div class="activity-timeline-wrapper">
            <div class="activity-timeline-body">
              <div class="activity-timeline-list">
                <ScrollWrapper>
                  <div
                    class="activity-timeline-item"
                    v-for="(schedule, index) in detail.date_list"
                    :key="index"
                    @click="changeTime(schedule.id, schedule.departure_date)"
                  >
                    <div class="activity-timeline-link">
                      <div class="relative-activity">
                        <div
                          class="relative-activity-main"
                          :class="{ checked: timeId === schedule.id }"
                        >
                          <div class="relative-activity-content">
                            <div class="relative-activity-time">
                              <span>{{ schedule.departure_date }}</span>
                              <!-- <span class="relative-activity-week">周一</span>
                              <span> ~ </span>
                              <span>01/27</span> -->
                            </div>
                            <div class="relative-activity-status">
                              <span class="relative-activity-status-text">
                                {{ getScheduleStatusCn(schedule.status) }} |
                                {{ schedule.person_num }}人
                              </span>
                            </div>
                          </div>
                          <!-- <div
                            class="relative-activity-key-point"
                            style="background-color:#ffab0b; border-color:#e79801;"
                          >
                            春节跨年
                            <div class="relative-activity-foot">
                              <i
                                src=""
                                class="v-pointer"
                              />
                            </div>
                          </div> -->
                        </div>
                        <div class="relative-activity-connecter">
                          <div
                            class="left-circle"
                            :class="{ checked: !!schedule.checked }"
                          ></div>
                          <div
                            class="right-circle"
                            :class="{ checked: !!schedule.checked }"
                          ></div>
                          <div class="left-center-bg"></div>
                          <div class="right-center-bg"></div>
                          <div class="small-left-circle"></div>
                          <div class="small-right-circle"></div>
                          <div class="left-center-line"></div>
                          <div
                            class="right-center-line"
                            v-if="index !== detail.date_list.length - 1"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ScrollWrapper>
              </div>
            </div>
          </div>
          <!-- 查看日历 -->
          <!-- <a
            class="activity-calendar"
            href=""
            ><div class="calendar-nav"></div
          ></a> -->
        </div>
      </div>

      <div class="activity-joiner">
        <div class="activity-joiner-header">
          <div class="activity-already-joined" v-if="detail.type == typeAct">
            已参加的人 (
            <span class="highlight-text">{{
              detail.current_time.min_person_num
            }}</span
            >人成团 )
          </div>
          <div class="activity-already-joined" v-else>
            已参加的人
            <span class="highlight-text">销量:{{ detail.fsales }}</span>
          </div>
          <div class="activity-joiner-count" v-if="detail.type == typeAct">
            总共<span class="highlight-text">{{
              detail.current_time.sale_num
            }}</span
            >/{{ detail.current_time.person_num }}人&nbsp;
            <!-- <i class="joiners-nav-ico"></i> -->
          </div>
          <div class="clearfix"></div>
        </div>
        <div class="joiner-list">
          <div
            class="joiner-item"
            v-for="(joiner, index) in detail.person"
            :key="index"
          >
            <a class="joiner-item-link" href="javascript:">
              <div class="joiner-img">
                <div class="joiner-body">
                  <div class="joiner-image-wrapper">
                    <img class="joiner-image" v-lazy="joiner.avatar" />
                  </div>
                </div>
              </div>
              <div class="joiner-name">{{ joiner.nickname }}</div>
            </a>
          </div>
          <div
            v-if="detail.person.length == 20"
            style="text-align: center; font-size: 18px;"
          >
            ...
          </div>
          <!-- <div class="clearfix"></div> -->
        </div>
      </div>

      <div class="activity-full-info">
        <yd-tab v-model="tab1" active-color="#35C87A">
          <yd-tab-panel label="活动介绍">
            <div class="activity-html-body">
              <div class="activity-content-block" v-html="detail.description" />
            </div>
          </yd-tab-panel>
          <yd-tab-panel label="方案细则">
            <div class="activity-html-body">
              <div class="activity-content-block">
                <div class="activity-content-block-head">详细方案</div>
                <yd-timeline>
                  <template v-for="(schedule, sindex) in detail.scheduling">
                    <yd-timeline-item
                      v-show="false"
                      :key="sindex"
                    ></yd-timeline-item>
                    <yd-timeline-item :key="sindex + 1">
                      <h4 v-show="schedule.title">{{ schedule.title }}</h4>
                      <p
                        class="schedule-block"
                        v-for="(timeItem, tindex) in schedule.time_list"
                        :key="tindex"
                      >
                        <span class="pull-left time left-item"
                          ><i class="left-text">{{ timeItem.time }}</i></span
                        ><span class="span pull-left right-item">{{
                          timeItem.desc
                        }}</span>
                      </p>
                      <div class="travel-base-info">
                        <p style="margin-top:10px;" v-if="schedule.dining">
                          <i class="dinning-ico"></i
                          ><span class="bolder left-item"
                            ><i class="left-text">用餐:</i></span
                          ><span class="span pull-left right-item">{{
                            schedule.dining
                          }}</span>
                        </p>
                        <p style="margin-top:10px;" v-if="schedule.bed">
                          <i class="bed-ico"></i
                          ><span class="bolder left-item"
                            ><i class="left-text">住宿:</i></span
                          ><span class="span pull-left right-item">{{
                            schedule.bed
                          }}</span>
                        </p>
                        <p style="margin-top:10px;" v-if="schedule.traffic">
                          <i class="traffic-ico"></i
                          ><span class="bolder left-item"
                            ><i class="left-text">交通:</i></span
                          ><span class="span pull-left right-item">{{
                            schedule.traffic
                          }}</span>
                        </p>
                      </div>
                    </yd-timeline-item>
                  </template>
                </yd-timeline>
              </div>

              <div class="activity-content-block">
                <div class="activity-content-block-head">细则说明</div>
                <div
                  class="activity-content-block-body"
                  v-html="detail.intend_description"
                ></div>
              </div>
            </div>
          </yd-tab-panel>
          <yd-tab-panel label="费用须知">
            <div class="activity-html-body">
              <div
                class="activity-content-block"
                v-html="detail.code_description"
              />
            </div>
          </yd-tab-panel>
        </yd-tab>
      </div>

      <div class="operate-group">
        <div class="activity-btn">
          <router-link class="btn-link" :to="{ name: 'Index' }">
            <div class="img-wrapper">
              <i class="center-block home-ico" />
            </div>
            <div class="btn-label" style="color:#f88834;">更多活动</div>
          </router-link>
        </div>
        <div class="activity-btn">
          <router-link :to="'/cart'" class="item animated btn-link">
            <i class="iconfont icon-gouwuche1"></i>
            <div class="btn-label">购物车</div>
          </router-link>
        </div>
        <!-- <div class="activity-btn enter-group">
          <a class="btn-link">
            <div class="img-wrapper">
              <img
                class="btn-img"
                src=""
              />
            </div>
            <div class="btn-label">进群</div>
          </a>
        </div> -->

        <div
          class="activity-btn joinCart"
          @click="joinCart"
          v-if="detail.type != typeAct"
        >
          <div class="btn-link">加入购物车</div>
        </div>
        <div class="activity-btn participate">
          <!-- 判断是否可以显示倒计时 -->
          <router-link
            v-if="detail.type == typeAct"
            :to="{
              name: 'Apply',
              query: {
                city_id: cityId,
                time_id: timeId,
                date_cn: dateCn,
                id: id,
                city_name: cityName,
                price: detail.price
              }
            }"
            class="btn-link"
            >立即报名</router-link
          >
          <div v-else class="btn-link" @click="buy">立即下单</div>
        </div>
        <div class="clearfix"></div>
      </div>
      <Product-window v-on:changeFun="changeFun" :attr="attr"></Product-window>
      <CouponPop v-on:changeFun="changeFun" :coupon="coupon"></CouponPop>
    </div>
    <div class="margin-bottom-holder"></div>
  </div>
</template>
<script>
import ProductWindow from "@components/ProductWindow";
import CouponPop from "@components/CouponPop";
import UserEvaluation from "@components/UserEvaluation";
import { Tab, TabPanel } from "vue-ydui/dist/lib.rem/tab";
import { getActivityDetail } from "@api/activity";
import { getCollectActivityAdd, getCollectDel, getCoupon } from "@api/user";
import { getCityList } from "@api/public";
import { TimeLine, TimeLineItem } from "vue-ydui/dist/lib.rem/timeline";
import ScrollWrapper from "@components/ScrollWrapper";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { postCartAdd } from "@api/store";

export default {
  data() {
    return {
      typeAct: "activity",
      couponList: [],
      replyCount: "",
      replyChance: "",
      reply: [],
      coupon: {
        coupon: false,
        list: []
      },
      attrTxt: "请选择",
      attrValue: "",
      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {}
      },
      isOpen: false, //是否打开属性组件
      productValue: [],

      schedules: [
        {
          checked: true
        },
        {},
        {}
      ],
      cities: [],
      id: "",
      cityId: "",
      cityName: "",
      timeId: "",
      dateCn: "",
      tab1: 0,
      joiners: [{}, {}, {}],
      detail: null,
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      showOtherPrice: false
    };
  },
  components: {
    [Tab.name]: Tab,
    [TabPanel.name]: TabPanel,
    [TimeLine.name]: TimeLine,
    [TimeLineItem.name]: TimeLineItem,
    ScrollWrapper,
    ProductWindow,
    CouponPop,
    UserEvaluation,
    swiper,
    swiperSlide
  },
  mounted() {
    this.id = parseInt(this.$route.query.id);
    this.cityId = parseInt(this.$route.query.city_id || 0);
    this.timeId = parseInt(this.$route.query.time_id || 0);
    this.$dialog.loading.open("详情数据加载中....");
    getCityList().then(res => {
      this.$set(this, "cities", res.data);
      this.loadDetail();
      this.coupons();
    });
  },
  methods: {
    //打开优惠券插件；
    couponTap: function() {
      let that = this;
      that.coupons();
      that.coupon.coupon = true;
    },
    changecoupon: function(msg) {
      this.coupon.coupon = msg;
      this.coupons();
    },
    currentcoupon: function(res) {
      let that = this;
      that.coupon.coupon = false;
      that.$set(that.coupon.list[res], "is_use", true);
    },
    //可领取优惠券接口；
    coupons: function() {
      let that = this,
        q = { page: 1, limit: 20 };
      getCoupon(q).then(res => {
        that.$set(that, "couponList", res.data || []);
        that.$set(that.coupon, "list", res.data);
      });
    },
    changeCity(value) {
      if (value == this.$route.query.city_id) return;
      this.cityId = value;
      this.cityName = this.cities[value].name;
      this.updateDetailLink();
    },
    changeTime(value, time) {
      if (value == this.$route.query.time_id) return;
      this.timeId = value;
      this.dateCn = time;
      this.updateDetailLink();
    },
    updateDetailLink() {
      this.$router.replace({
        name: "ActivityDetails",
        query: {
          id: this.id,
          city_id: this.cityId,
          time_id: this.timeId
        }
      });
      this.$dialog.loading.open("loading...");
      this.loadDetail();
    },
    getScheduleStatusCn(status) {
      let statusCn = "";
      switch (status) {
        case 0:
          statusCn = "火热报名中";
          break;
        case 1:
          statusCn = "已成团";
          break;
        case 2:
          statusCn = "已满员";
          break;
      }
      return statusCn;
    },
    loadDetail() {
      this.$dialog.loading.open("loading...");
      let that = this;
      getActivityDetail(this.id, {
        city_id: that.cityId,
        time_id: that.timeId
      })
        .then(res => {
          let applyCount = 0;
          this.detail = res.data.storeInfo;
console.info(this.detail.scheduling)

          this.$set(that, "replyCount", res.data.replyCount);
          this.$set(that, "replyChance", res.data.replyChance);
          this.reply = res.data.reply ? [res.data.reply] : [];
          this.detail.join_count = this.detail.person.length;
          this.detail.person.forEach(element => {
            applyCount += element.num;
          });
          this.detail.apply_count = applyCount;
          if (this.detail.type == this.typeAct) {
            if (
              !this.timeId &&
              this.detail.date_list &&
              this.detail.date_list.length
            ) {
              this.timeId = this.detail.date_list[0].id;
            }
            this.dateCn = this.detail.date_list.filter(
              item => item.id === this.timeId
            )[0].departure_date;

            this.cityId = this.detail.city_id;
            this.cityName = this.cities[this.detail.city_id].name;
          } else {
            this.attr.productAttr = res.data.productAttr;
            this.productValue = res.data.productValue;
            this.DefaultSelect();
          }

          this.$dialog.loading.close();
        })
        .catch(err => {
          console.info(err);
          this.$dialog.loading.close();
          if (err.msg) {
            this.$dialog.toast({ mes: err.msg });
          }
        });
    },
    collectActivity() {
      this.detail = {
        ...this.detail,
        userCollect: true
      };
      this.$dialog.loading.open("loading...");
      getCollectActivityAdd(this.detail.id, this.cityId, this.timeId)
        .then(res => {
          console.log(res);
          this.$dialog.loading.close();
        })
        .catch(err => {
          this.$dialog.loading.close();
          this.$dialog.error(err.msg ? err.msg : "收藏活动失败!");
        });
    },
    cancelCollectActivity() {
      this.detail = {
        ...this.detail,
        userCollect: false
      };
      this.$dialog.loading.open("loading...");
      getCollectDel(this.detail.id)
        .then(res => {
          console.log(res);
          this.$dialog.loading.close();
        })
        .catch(err => {
          this.$dialog.loading.close();
          this.$dialog.error(err.msg ? err.msg : "取消收藏活动失败");
        });
    },
    //  点击加入购物车按钮
    joinCart: function() {
      //0=加入购物车
      this.tapBuy(0);
    },
    //  直接购买
    buy: function() {
      //0=加入购物车
      this.tapBuy(1);
    },
    //立即购买；
    tapBuy: function(news) {
      let productSelect = this.productValue[this.attrValue];
      //打开属性
      if (this.attrValue) {
        //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
        this.attr.cartAttr = !this.isOpen ? true : false;
      } else {
        if (this.isOpen) this.attr.cartAttr = true;
        else this.attr.cartAttr = !this.attr.cartAttr;
      }
      //只有关闭属性弹窗时进行加入购物车
      if (this.attr.cartAttr === true && this.isOpen === false)
        return (this.isOpen = true);
      //如果有属性,没有选择,提示用户选择
      if (
        this.attr.productAttr.length &&
        productSelect === undefined &&
        this.isOpen === true
      ) {
        return this.$dialog.toast({ mes: "产品库存不足，请选择其它" });
      }
      let q = {
        productId: this.detail.id,
        cartNum: this.attr.productSelect.cart_num,
        new: news,
        uniqueId:
          this.attr.productSelect !== undefined
            ? this.attr.productSelect.unique
            : ""
      };
      let that = this;
      postCartAdd(q)
        .then(function(res) {
          that.isOpen = false;
          that.attr.cartAttr = false;
          if (news) {
            that.$router.push({ path: "/order/submit/" + res.data.cartId });
          } else {
            that.$dialog.toast({
              mes: "添加购物车成功"
            });
          }
        })
        .catch(res => {
          that.isOpen = false;
          return that.$dialog.toast({ mes: res.msg });
        });

      //this.$router.push({ name: "Apply", query: q });
    },
    //购物车；
    ChangeCartNum: function(changeValue) {
      //changeValue:是否 加|减
      //获取当前变动属性
      let productSelect = this.productValue[this.attrValue];
      //如果没有属性,赋值给商品默认库存
      if (productSelect === undefined && !this.attr.productAttr.length)
        productSelect = this.attr.productSelect;
      //无属性值即库存为0；不存在加减；
      if (productSelect === undefined) return;
      let stock = productSelect.stock || 0;
      let num = this.attr.productSelect;
      if (changeValue) {
        num.cart_num++;
        if (num.cart_num > stock) {
          this.$set(this.attr.productSelect, "cart_num", stock);
          this.$set(this, "cart_num", stock);
        }
      } else {
        num.cart_num--;
        if (num.cart_num < 1) {
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "cart_num", 1);
        }
      }
    },
    //将父级向子集多次传送的函数合二为一；
    changeFun: function(opt) {
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";
      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value);
    },
    //打开属性插件；
    selecAttrTap: function() {
      this.attr.cartAttr = true;
      this.isOpen = true;
    },
    changeattr: function(msg) {
      this.attr.cartAttr = msg;
      this.isOpen = false;
    },
    //选择属性；
    ChangeAttr: function(res) {
      let productSelect = this.productValue[res];
      if (productSelect) {
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", res);
        this.$set(this, "attrTxt", "已选择");
      } else {
        this.$set(this.attr.productSelect, "image", this.detail.image);
        this.$set(this.attr.productSelect, "price", this.detail.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      }
    },
    //默认选中属性；
    DefaultSelect: function() {
      let productAttr = this.attr.productAttr;
      let value = [];
      for (let i = 0; i < productAttr.length; i++) {
        this.$set(productAttr[i], "index", 0);
        value.push(productAttr[i].attr_values[0]);
      }
      //sort();排序函数:数字-英文-汉字；
      let productSelect = this.productValue[value.sort().join(",")];

      if (productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.detail.store_name
        );
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", value.sort().join(","));
        this.$set(this, "attrTxt", "已选择");
      } else if (!productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.detail.store_name
        );
        this.$set(this.attr.productSelect, "image", this.detail.image);
        this.$set(this.attr.productSelect, "price", this.detail.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      } else if (!productSelect && !productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.detail.store_name
        );
        this.$set(this.attr.productSelect, "image", this.detail.image);
        this.$set(this.attr.productSelect, "price", this.detail.price);
        this.$set(this.attr.productSelect, "stock", this.detail.stock);
        this.$set(this.attr.productSelect, "unique", this.detail.unique || "");
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      }
    }
  }
};
</script>
